import MutationTypes from '@/store/mutation-types';

export default {
    [MutationTypes.APPLICATION_ERROR] (state, error) {
        state.applicationError = error;
    },

    [MutationTypes.SET_LANGUAGE]: (state, language) => {
        state.language = language;
    },

    [MutationTypes.SET_SCREEN_SOURCE]: (state, source) => {
        state.screenSource = source;
    },

    [MutationTypes.SET_IFRAME_PARAMS] (state, params) {
        state.iframeParams = params;
    },

    [MutationTypes.SET_VIEWPORT] (state, payload) {
        state.viewport = payload;
    },

    [MutationTypes.SET_IS_IN_EDIT_MODE] (state, flag) {
        state.isInEditMode = flag;
    },

    [MutationTypes.SET_EDIT_CONFIGURATION] (state, payload) {
        state.editConfiguration = payload;
    },

    [MutationTypes.SET_INVESTMENT_OBJECTIVE] (state, objective) {
        state.investmentObjective = objective;
    },

    [MutationTypes.SET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED] (state, strategy) {
        state.previousInvestmentStrategySelected = strategy;
    },

    [MutationTypes.RESET_PREVIOUS_INVESTMENT_STRATEGY_SELECTED] (state) {
        state.previousInvestmentStrategySelected = null;
    },

    [MutationTypes.SET_INVESTMENT_STRATEGY_SELECTED] (state, strategy) {
        state.investmentStrategySelected = strategy;
    },

    [MutationTypes.SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_INVESTMENT_HORIZON] (
        state,
        strategy,
    ) {
        state.investmentStrategyRecommendedBasedOnInvestmentHorizon = strategy;
    },

    [MutationTypes.SET_INVESTMENT_STRATEGY_RECOMMENDED_BASED_ON_RISK_TOLERANCE] (
        state,
        strategy,
    ) {
        state.investmentStrategyRecommendedBasedOnRiskTolerance = strategy;
    },

    [MutationTypes.SET_INVESTMENT_THEME] (state, theme) {
        state.investmentTopic = theme;
    },

    [MutationTypes.SET_REGIONAL_FOCUS] (state, focus) {
        state.investmentRegion = focus;
    },

    [MutationTypes.SET_OTHER_INVESTMENTS] (state, investment) {
        state.otherInvestments = investment;
    },

    [MutationTypes.SET_INVESTMENT_AMOUNT] (state, amount) {
        state.investmentAmount = amount;
    },

    [MutationTypes.SET_INVESTMENT_HORIZON] (state, horizon) {
        state.investmentHorizon = horizon;
    },

    [MutationTypes.SET_DETAILS_FILTER_TYPE] (state, type) {
        state.selectedDetailsFilterType = type;
    },

    [MutationTypes.SET_DETAILS_SUB_FILTER_TYPE] (state, type) {
        state.selectedDetailsSubFilterType = type;
    },

    [MutationTypes.SET_MODEL_PORTFOLIO_DETAILS] (state, details) {
        state.modelPortfolioDetails = details;
    },

    [MutationTypes.SET_MODEL_PORTFOLIO_POSITIONS] (state, positions) {
        state.modelPortfolioPositions = positions;
    },

    [MutationTypes.SET_RISK_TOLERANCE_BLOCK_1_SELECTED_ANSWER] (state, selection) {
        state.riskToleranceBlock1SelectedAnswer = selection;
    },

    [MutationTypes.SET_RISK_TOLERANCE_BLOCK_2_SELECTED_ANSWER] (state, selection) {
        state.riskToleranceBlock2SelectedAnswer = selection;
    },

    [MutationTypes.SET_RISK_TOLERANCE_BLOCK_3_SELECTED_ANSWER] (state, selection) {
        state.riskToleranceBlock3SelectedAnswer = selection;
    },

    [MutationTypes.SET_LAST_OPEN_SECTION] (state, section) {
        state.openSections = state.openSections.filter(
            s => s.index <= section.index,
        );
    },

    [MutationTypes.SET_EMAIL_ADDRESS] (state, emailAddress) {
        state.emailAddress = emailAddress;
    },

    [MutationTypes.ADD_OPEN_SECTION] (state, section) {
        state.openSections.push(section);
    },

    [MutationTypes.REMOVE_OPEN_SECTION] (state, section) {
        state.openSections = state.openSections.filter(
            openSection => openSection.name !== section.name,
        );
    },

    [MutationTypes.SET_INVESTMENT_DIAGRAM_RESPONSE] (state, data) {
        state.investmentDiagramResponse = data;
    },

    [MutationTypes.SET_SETTINGS] (state, settings) {
        state.settings = settings;
    },

    [MutationTypes.SET_USER_IS_CUSTOMER] (state, userIsCustomer) {
        state.userIsCustomer = userIsCustomer;
    },
};
